export  default {
    SELECTED_TEMPLATE : "SELECTED_TEMPLATE",
    CONDITION_COLORS_BACKGROUND: "CONDITION_COLORS_BACKGROUND",
    TITLE_FONT_COLOR: "TITLE_FONT_COLOR",
    SUBTITLE_FONT_COLOR:"SUBTITLE_FONT_COLOR",
    CONDITION_COLORS_FONTCOLOR: "CONDITION_COLORS_FONTCOLOR",
    SELECTED_TIMELINE_TEMPLATE:"SELECTED_TIMELINE_TEMPLATE",
    BATCH_FONT_COLOR:"BATCH_FONT_COLOR"
  } 